/**
 * Function to manage asynchronous partial page loads
 * @class AjaxNavigation
 * @memberof EBContext.modules
 */
EBContext.modules.AjaxNavigation = function () {
	var self = this;
	
	this.enabled = true;
	this.navigationEnabled = true;
	this.version = new Date().getTime();
	this.env = {};
	this.crcTable = null;
	
	/** 
	 * @property {EBContext.modules.AjaxNavigation.ajaxQueueItem[]} [ajaxQueue=[]] Array of AJAX request representation objects, effectively creating a requests queue
	 */
	this.ajaxQueue = [];
	
	var defaultLoader = {
		enabled: true,
		useOverlay: true,
		ajaxQueue: self.ajaxQueue,
		fnLoaderStart: function (loader) {
            loader = loader || this.options.loader;
			if(!document.body) return setTimeout(()=>loader.fnLoaderStart(loader), 20);
			if (loader.useOverlay) {
				var overlayEl = document.getElementById('asyncLoadingOverlay') || document.createElement('div');
				overlayEl.id = 'asyncLoadingOverlay';
				overlayEl.style.cssText = 'position:fixed;width:100%;height:100%;top:0;left:0;z-index:65530;background-color:#fff5';
				document.body.appendChild(overlayEl);
			}

			var loadingElement = document.getElementById('ajaxLoader') || document.createElement('div');
			loadingElement.id = 'ajaxLoader';
			loadingElement.className = 'defaultLoader';
			loadingElement.style.cssText = 'position:fixed;top:50%;left:50%;margin-top:-1rem;margin-left:-1rem;z-index:65531;width:2rem;height:2rem;padding:1.5rem;border-radius:.5rem';
			document.body.appendChild(loadingElement);
		},
		fnLoaderEnd: function (loader) {
            loader = loader || this.options.loader;
			var loadingElement = document.getElementById('ajaxLoader');
			if (loadingElement) loadingElement.parentNode.removeChild(loadingElement);

			var overlayEl = document.getElementById('asyncLoadingOverlay');
			if (overlayEl) overlayEl.parentNode.removeChild(overlayEl);
		},
		fnLoaderUpdate: function (loader) {
            loader = loader || this.options.loader;
			if (loader.ajaxQueue.length === 0) {
				EBContext.ready(()=>loader.fnLoaderEnd(loader));
			} else {
				//@TODO - zobraz� po�et zb�vaj�c�ch ajax request� n�kde v loaderu
			}
		}
	};

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.ajaxQueueItem
	 * @property {string} url URL of ajax request
	 * @property {boolean} [cancelled=false] If `true`, response from this request won't be processed
	 * @property {boolean} navigation Identifies AJAX request as navigational
	 */

	/**
	 * @callback EBContext.modules.AjaxNavigation.fnBlockInit
	 * @param {HTMLElement} scope HTML DOM Element as scope to limit effect of this callback only to its descendant elements
	 */

	/**
	 * @callback EBContext.modules.AjaxNavigation.fnTestElement
	 * @param {HTMLElement} element HTML DOM Element to test if fit for bind AjaxNavigation
	 * @returns {boolean} If `true`, element is fit for use with AjaxNavigation
	 */

	/**
	 * @callback EBContext.modules.AjaxNavigation.fnBindElement
	 * @param {HTMLElement} element HTML DOM Element to bind AjaxNavigation to
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.bindElementsObject
	 * @property {string} selector CSS Selector to find all matching elements to bind
	 * @property {EBContext.modules.AjaxNavigation.fnTestElement} fnTestElement
	 * @property {EBContext.modules.AjaxNavigation.fnBindElement} fnBindElement
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.errorOptions
	 * @param {string} [verbose='unspecified type'] Detailed information about error - verbose description
	 * @param {string} [code] Specific part of code in which error occured
	 * @param {string} [error] Error tree from catch statement
	 * @param {boolean} [dependent=false] indicates, whether the response data are dependent on AJAX requests, or can be obtained by other means (e.g. full reload)
	 */

	/**
	 * @callback EBContext.modules.AjaxNavigation.fnAjaxError
	 * @param {string} response Response text to AJAX request in which error occurred
	 * @param {EBContext.modules.AjaxNavigation.errorOptions} [options] Detailed information about error, special error handling options
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.options
	 * @property {string} [defaultReload='page,userMenu'] Enumeration of blocks that will be reloaded by navigation, if not specified otherwise
	 * @property {string} [defaultSubPage='content'] Name of the block with primary 'subPage', to insert links to local JS and CSS files by navigation
	 * @property {string} [defaultBindElement='link'] Name of default 'bindElements' entry to use if type not specified for shorter functions calls
	 * @property {EBContext.modules.AjaxNavigation.fnBlockInit} [fnBlockInit] Callback, that is called for each block replaced by navigation
	 * @property {function} [fnPageInit] Callback, that is called after each navigation request
	 * @property {Object} [loader] Settings Object for default 'loader' functionality
	 * @property {boolean} [loader.enabled=true] Enables or disables use of loader globally
	 * @property {boolean} [loader.useOverlay=true] If enabled, page overlay is shown under loader, disabling user from creating any more requests
	 * @property {function} [loader.fnLoaderStart] Callback to display loader and optionally page overlay
	 * @property {function} [loader.fnLoaderEnd] Callback to remove loader and page overlay
	 * @property {function} [loader.fnLoaderUpdate] Callback to update loader according to 'loader.ajaxQueue' length
	 * @property {Object} [scrollTop] Settings Object for 'scrollTop' behavior on navigation
	 * @property {boolean} [scrollTop.enabled=true] Option to globally enable/disable 'scrollTop' on navigation
	 * @property {boolean} [scrollTop.mobileOnly=false] If `true`, scrollTop will be called only on screens smaller than 'maxScreenWidth' (px)
	 * @property {boolean} [scrollTop.upOnly=false] If `true`, scrollTop will be called only when scrolled below position of 'defaultElement'
	 * @property {number} [scrollTop.maxScreenWidth=767] Represents max width of screen that is still considered mobile
	 * @property {string} [scrollTop.defaultElement='body'] CSS selector of DOM Element to scrollTop to
	 * @property {number} [scrollTop.topOffset=0] Offset (px) from top of 'scrollTop.defaultElement'
	 * @property {Object} [scrollTop.options] Options Object for 'element.scrollIntoView(options)' native JS function
	 * @property {Object} [saveElementsState] Settings Object for 'saveElementsState' behavior on navigation
	 * @property {boolean} [saveElementsState.enabled=true] If `true`, selected properties of all elements having both 'name' and 'id' will be saved to history object
	 * @property {Object.<string, string[]>} [saveElementsState.templates] JS Object, where keys are CSS Selectors, and values are string[] with names of DOM Elements attributes
	 * @property {null|string} [ignoreElements=null] HTML DOM selector of elements to ignore while binding ajaxNav events
	 * @property {EBContext.modules.AjaxNavigation.bindElementsObject} [bindElements]
	 * @property {EBContext.modules.AjaxNavigation.fnAjaxError} [fnAjaxError] Callback called on various AJAX-related errors (no response, eval error, etc.)
	 */

	/**
	 * @property {EBContext.modules.AjaxNavigation.options} options Navigation options extendable on init
	 */
	this.options = {
		defaultReload: ['page'],
		defaultSubPage: 'content',
		defaultBindElement: 'link',
		initElements: null,
		fnBlockInit: function (scope) {
			if (self.options.debug) console.info('%c@fnBlockInit: No block init function (block \'' + EBContext.utils.element.getSelector(scope) + '\').', EBContext.options.consoleStyles.infoMsg);
			return true;
		},
		fnPageInit: function () {
			if (self.options.debug) console.info('%c@fnPageInit: No page init function.', EBContext.options.consoleStyles.infoMsg);
			return true;
		},
		fnOnNavigation: function () {
			if (self.options.debug) console.info('%c@fnOnNavigation: No navigation callback.', EBContext.options.consoleStyles.infoMsg);
			return true;
		},
		loader: defaultLoader,
		scrollTop: {
			enabled: true,
			mobileOnly: false,
			upOnly: false,
			maxScreenWidth: 767,
			defaultElement: 'body',
			topOffset: 0,
			options: {
				behavior: 'smooth',
				block: 'start',
				inline: 'start'
			}
		},
		saveElementsState: {
			enabled: true,
			templates: {
				'[data-save*="class"]': ['className'],
				default: ['value', 'checked', 'selected', 'readonly', 'disabled', 'required', 'multiple', 'min', 'max', 'step']
			}
		},
		ignoreElements: null,
		bindElements: {
			link: {
				selector: 'a',
				fnTestElement: function (element) {
					return (
						element.host === window.location.host &&
						element.getAttribute('data-ajax') !== 'off' &&
						// element.getAttribute('href') !== '' &&
						element.pathname.indexOf('default.asp') < 0 &&
						element.pathname.indexOf('update.asp') < 0 &&
						element.pathname.indexOf('/files/') < 0 &&
						element.target === '' &&
						!(/(\?|\&)ajax=0/gi).test(element.href) &&
						!(self.options.ignoreElements && element.matches(self.options.ignoreElements))
					);
				},
				fnBindElement: function (element) {
					EBContext.utils.element.setOverride(element, 'onclick', function(){
						if(element.pathname === window.location.pathname && element.href.indexOf('#') >= 0) return true;
						var options = EBContext.utils.parseObj(element.getAttribute('data-ajax'));
						options.reload = options.reload || self.options.defaultReload.join(',');
						var url = EBContext.utils.createURL(element, options);
						var ajaxURL = EBContext.utils.createAjaxURL(element, options);
						
						var postData = options.postData || null;
						if(typeof postData === 'function') postData = postData();
						
						return self.navigationTrigger(url, ajaxURL, postData, options);
					}, true);
				}
			},
			form: {
				selector: 'form',
				fnTestElement: function (element) {
					var virtualAnchor = EBContext.utils.createAnchor(element.action);
					return (
						(!element.getAttribute('action') || virtualAnchor.host === window.location.host) &&
						element.getAttribute('data-ajax') !== 'off' &&
						virtualAnchor.pathname.indexOf('default.asp') < 0 &&
						virtualAnchor.pathname.indexOf('update.asp') < 0 &&
						(element.target === '' || element.target === 'dummy') &&
						!(self.options.ignoreElements && element.matches(self.options.ignoreElements)) &&
						!(virtualAnchor.pathname === window.location.pathname && virtualAnchor.hash !== '')
					);
				},
				fnBindElement: function (element) {
					EBContext.utils.prepareForm(element);
					EBContext.utils.element.setOverride(element, 'onsubmit', function() {
						let processedForm = EBContext.utils.processForm(element);
						if(!processedForm) return false;
						self.saveState();
						let res = self.navigationTrigger(processedForm.virtualAnchor.href, processedForm.ajaxURL, processedForm.postData, processedForm.options);
						if(processedForm.options.overrideURL) return true;
						return res;
					}, true);
				}
			}
		},
		fnAjaxError: function (response, options) {
			options = options || {};
			options.verbose = options.verbose || 'unspecified type';
			console.error('%cAJAX error (' + options.verbose + ') - description:', EBContext.options.consoleStyles.errorMsg);

			if (options.error) {
				console.groupCollapsed("%cShow error", EBContext.options.consoleStyles.errorBtn);
				console.error(options.error);
				console.groupEnd();
			}

			if (options.code) {
				console.groupCollapsed("%cShow code", EBContext.options.consoleStyles.infoBtn);
				console.info('%c' + options.code, EBContext.options.consoleStyles.code);
				console.groupEnd();
			}

			console.groupCollapsed("%cShow AJAX response", EBContext.options.consoleStyles.infoBtn);
			console.info('%c' + response, EBContext.options.consoleStyles.code);
			console.groupEnd();

			/* Pokud lze v�sledek ajax dotazu z�skat reloadem (!dependent) a nen� zapnut� debug m�d, tak zobrazit confirm k reloadu str�nky  */
			if (false && !options.dependent && !self.options.debug && confirm(EBContext.resource('ERR_CHYBA_NAVIGACE'))) {
				window.location.reload();
			}
			/* Jinak se alespo� pokusit n�v�t�vn�ka upozornit, �e se n�co nepovedlo */
			else if (self.options.fnErrorNotify && typeof self.options.fnErrorNotify === 'function') {
				// window.history.back();
				self.options.fnErrorNotify(response, options);
			}
			options.loader.fnLoaderEnd(options.loader);
			return false;
		},
		fnErrorNotify: function (response, options) {
			// alert(EBContext.resource('ERR_CHYBA_NAVIGACE'));
			var url;
			var text, heading;
			var debug = self.options.debug;
			text = EBContext.resource('ERR_CHYBA_NA_SERVERU');
			if (response) {
				// response = response.replace(/<\!--[^>]*-->/g, '').replace(/(<[^>]+>)/g, function(occurence){ return occurence.toLowerCase() });
				let url = options.url;
				if(url[0] === '/') url = window.location.origin + url;
				let urlStr = '<a href="' + url + '">' + url + '</a>';
				try {
					var responseObj;
					eval('responseObj = ' + response.substring(response.indexOf('{'))); // jshint ignore:line
					heading = EBContext.utils.getObj(['head', 'title'], responseObj) || options.responseStatus;
					text = EBContext.utils.getObj(['html', 'page'], responseObj) || options.verbose || text; // + '</font>';
				} catch (error) {
					if(response.indexOf('<h1>') === 0 && response.indexOf('</h1>') > 0){
						let statusStr = '<br>HTTP status: <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/' + options.responseStatus + '" target="_blank">' + options.responseStatus + '</a>';
						text = text + '<details>' + response.replace('<h1>', '<summary>').replace('</h1>', '</summary><div class="selectable">') + statusStr + '<br>URL: ' + urlStr + '</div></details>';
						console.error('Chyba eval response. V response je nejsp�e HTML.');
					}
				}
				if(self.options.debug){
					let formatCode = codeStr=>{
						codeStr = codeStr.toString();
						codeStr = codeStr.replace(/ {4}/g, '\t');
						while(codeStr.search(/\n\t.*/g) > -1 && codeStr.search(/\n[^\t].*/g) === -1) codeStr = codeStr.replace(/\n\t/g, '\n');
						return codeStr.replace(/\t/g, '    ');
					};
					console.log(options);
					if(options.code){
						text += '<details class="alert alert-info p-1 mb-1"><summary>' + EBContext.resource('KOD') + '</summary><pre class="pre-scrollable bg-dark my-0 p-1"><code>' + formatCode(options.code) + '</code></pre></details>';
					}
					text += '<details class="alert alert-info p-1 mb-1"><summary>' + EBContext.resource('PODROBNOSTI') + '</summary><pre class="pre-scrollable bg-dark my-0 p-1"><code>' + formatCode(response) + '</code></pre></details>';
					if(options.error && options.error.stack){
						text += '<details class="alert alert-danger p-1 mb-1"><summary>' + EBContext.resource('CHYBA') + '</summary><pre class="pre-scrollable bg-dark my-0 p-1"><code>' + options.error.stack + '</code></pre></details>';
					}
				}
				heading = heading || EBContext.resource('CHYBA_SERVERU');
			}
			require(['EBContext_Modal'], ()=>{
				let errPopup = EBContext.confirm(
					text,
					function (resp) {
						if (resp) {
							url = (options.url + '&rnd=').split('&rnd=')[0];
							let cb = ()=>{EBContext.ajaxNav.ajaxCall(url, options.callback, options.post, options.options)};
							if(!debug || EBContext.options.debug) {
								return cb();
							}
							EBContext.utils.xmlHttp({
								url: '/?debug=1',
								callback: ()=>{
									EBContext.options.debug=true;
									cb();
								}
							});
						} else {
							window.location.href = '/';
						}
					}, {
						heading: heading,
						contentClass: 'errorMsg',
						btnEsc: { show: true },
						btnOK: {
							text: EBContext.resource('OPAKOVAT') + (debug ? ' (DEBUG)' : ''),
							title: EBContext.resource('OPAKOVAT')
						},
						btnCancel: {
							text: EBContext.resource('ODEJIT'),
							title: EBContext.resource('ODEJIT')
						}
					}
				);
				if(textSelector) textSelector(errPopup.modalEl);
			});
		},
		requestQueue: {
			ignoreNonNavOnNav: false,
			cancelOldNavOnNav: false
		},
		debug: EBContext.utils.getObj('data.session.ebServiceMode', EBContext)
	};
	this.events = {
		ready: new Event('EBContext.ajaxNav.ready', {'bubbles': true, 'cancellable': false, 'composed': true}),
		navigate: new Event('EBContext.ajaxNav.navigate', {'bubbles': true, 'cancellable': false, 'composed': true}),
		navigated: new Event('EBContext.ajaxNav.navigated', {'bubbles': true, 'cancellable': false, 'composed': true}),
		bodyReload: new Event('EBContext.ajaxNav.bodyReload', {'bubbles': true, 'cancellable': false, 'composed': true}),
		bodyReloaded: new Event('EBContext.ajaxNav.bodyReloaded', {'bubbles': true, 'cancellable': false, 'composed': true}),
		elementsRestored: new Event('EBContext.ajaxNav.elementsRestored', {'bubbles': true, 'cancellable': false, 'composed': true})
	};

	/**
	 * @callback EBContext.modules.AjaxNavigation.ajaxCallback
	 * @param {string|Object} response
	 * @param {string|Object} respOptions
	 */

	/**
	 * @typedef {Object.<string, EBContext.modules.AjaxNavigation.ajaxCallback>} EBContext.modules.AjaxNavigation.ajaxCallbackObject
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [beforeProcess] Is called before anything from response is processed, but only if request is not cancelled
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [evalError] Is called on error while evaluating response text as JS object
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [beforeEval] Is called before evaluation of scripts in response's reload blocks HTML
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [beforeHeadUpdate] Is called before title, meta tags, local JS/CSS and current page OID and version are updated
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [beforeScopedInit] Is called before scoped init function (initBlock/options.fnBlockInit) is called for every replaced block
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [noResponse] Is called when there is no text in ajaxCall's response
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback} [afterEval] Is called after scopedInit of all blocks (when everything has been processed)
	 * @property {EBContext.modules.AjaxNavigation.ajaxCallback|EBContext.modules.AjaxNavigation.fnAjaxError} [onError] Is called in case of a HTTP error
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.ajaxResponseOptions
	 * @property {string} [ctype] represents enctype of data (e.g. when sending data from HTML form)
	 * @property {Object} loader
	 * @property {boolean} navigation Identifies AJAX request as navigational
	 * @property {number} responseStatus HTTP status code of incomplete response
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.ajaxResponseObj
	 * @property {string} response Response string from AJAX request
	 * @property {(EBContext.modules.AjaxNavigation.ajaxCallback|EBContext.modules.AjaxNavigation.ajaxCallbackObject)} callback
	 * @property {EBContext.modules.AjaxNavigation.ajaxResponseOptions} options
	 */

	/**
	 * @property {Object.<string, EBContext.modules.AjaxNavigation.ajaxResponseObj>} ajaxResponses Object of received responses to be called in order according to `EBContext.modules.AjaxNavigation.ajaxQueue`
	 */
	this.ajaxResponses = {};

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.savedElement
	 * @property {string} element
	 * @property {Object} attributes
	 * @property {Object} properties
	 */

	/**
	 * @typedef {Object} EBContext.modules.AjaxNavigation.historyStateObj
	 * @property {number} historyId Represents the position of state in browser's tab history 
	 * @property {string} returnURL URL to be called via `ajaxCall` in order to load content for this history state 
	 * @property {Object} [pageData] Flat (serialisable) object to be used to save custom page elements state (e.g. parametric filter state)
	 * @property {string|FormData|null} postData String to be send as POST data via `ajaxCall` in order to load content for this history state
	 * @property {EBContext.modules.AjaxNavigation.savedElement[]} [savedElements] Array of saved elements used to emulate 'form memory' like functions native to many browsers
	 */

	/**
	 * @property {EBContext.modules.AjaxNavigation.historyStateObj} currentState Stores all variables tied to currently loaded history state
	 */
	this.currentState = EBContext.utils.extendObj(false, {
		historyId: 0,
		currentURL: window.location.href
	}, (window.history.state ? window.history.state : {}), {dump: []});

	/**
	 * @property {function[]} onload Array of callbacks to call when ajax navigation finish loading page content - substitutes document ready event for ajax navigation
	 */
	this.onload = [];
	
	this.navigationStatus = '';

	/**
	 * @property {Object.<EBContext.modules.AjaxNavigation.historyStateObj.historyId, EBContext.modules.AjaxNavigation.historyStateObj.reload>} reloadsHistory 
	 */
	this.reloadsHistory = {};

	/**
	 * @property {function} onAfterNavigation Callback that is called when navigation is complete. For internal use only
	 */
	this.onAfterNavigation = null;

	/**
	 * @property {function} subPageScriptEvt Callback that is called on local JS load. For internal use only
	 */
	this.subPageScriptEvt = null;

	/**
	 * @param {number} targetId historyId of target historyObj
	 * @returns {string[]} Array of ID's of blocks to reload
	 */
	this.getReloadBlocks = function (targetId, samePage) {
		var startId, endId;
		if (self.currentState.historyId > targetId) {
			startId = targetId + 1;
			endId = self.currentState.historyId;
		} else {
			startId = self.currentState.historyId + 1;
			endId = targetId;
		}
		var reloadBlocks = [];
		for (var i = startId; i <= endId; i++) {
			if (self.reloadsHistory[i]) {
				var blocksArr = self.reloadsHistory[i];
				if(!Array.isArray(blocksArr)) blocksArr = blocksArr.split(',');
				if(!samePage){
					for(var b = 0; b < blocksArr.length; b++){
						blocksArr[b] = blocksArr[b].replace(/\*/g, '');
						if(reloadBlocks.indexOf(blocksArr[b]) < 0) reloadBlocks.push(blocksArr[b]);
					}
				}
			}
		}
		
		return reloadBlocks;
	};
	
	this.setEnv = function(key, val) {
		function crc32(str) {
		    var crcTable = self.crcTable || (self.crcTable = self._makeCRCTable());
		    var crc = 0 ^ (-1);
		
		    for (var i = 0; i < str.length; i++ ) {
		        crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];
		    }
		
		    return (crc ^ (-1)) >>> 0;
		};
		if (key) self.env[key] = val;
		self.version = crc32(JSON.stringify(self.env));
		console.warn('set env', key, val, self.version);
	};
	
	this._makeCRCTable = function(){
	    var c;
	    var crcTable = [];
	    for(var n =0; n < 256; n++){
	        c = n;
	        for(var k =0; k < 8; k++){
	            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	        }
	        crcTable[n] = c;
	    }
	    return crcTable;
	}

	/**
	 * @param {EBContext.modules.AjaxNavigation.options} [options] Options object to extend default options object
	 */
	this.init = function (options) {
		self.setEnv('version', new Date().getTime());
		options = options || {};
		EBContext.utils.extendObj(true, self.options, options);
		
		if(!EBContext.utils.getObj('session.user.id', EBContext)) EBContext.utils.setObj(EBContext, 'session.user.id', '');
		
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		// saving state to history object when navigating outside site
		window.addEventListener(('onpagehide' in window ? 'pagehide' : 'unload'), function () {
			self.saveState();
		});

		// loading state and triggering navigation on browser history action
		window.addEventListener('popstate', function (event) {
			if ((window.location.href.toString() + '#').split('#')[0] === (self.currentState.currentURL + '#').split('#')[0]) {
				let scrollAnchorId = (window.location.href.toString() + '#').split('#')[1];
				if(scrollAnchorId){
					let scrollAnchorEl = document.getElementById(scrollAnchorId);
					if(scrollAnchorEl){
						window.scrollTo({top: scrollAnchorEl.offsetTop, left: 0, behavior:'smooth'});
					}
				}	
				return true;
			}
			if (event.state && self.currentState.httpStatus && self.currentState.httpStatus < 400 && self.currentState.httpStatus > 0) {
				if (event.state.returnURL) {
					let reload = self.getReloadBlocks(event.state.historyId, (event.state.processPostData===2)).join(',');
					let postData = (event.state.processPostData ? event.state.postData : null); // processPostData=0 - nezpracov�vat
					let popstateCallback = ()=>{
						self.navigationTrigger(location.href, null, postData, {
							reload: reload,
							masterPage: event.state.masterPage
						}, event);
					}
					if(postData && event.state.processPostData === 1){  // processPostData=1 - default (zobrazit confirm "Op�tovn� odesl�n� formul��e")
						EBContext.confirm(EBContext.resource('MSG_ZNOVU_ODESLAT_FORMULAR'), resp=>{
							if(resp){
								popstateCallback();
							} else {
								history.go(self.currentState.historyId - event.state.historyId);
							}
						}, {heading: EBContext.resource('ZNOVU_ODESLAT_FORMULAR')});
					} else { // processPostData=2 - zpracovat automaticky
						popstateCallback();
					}
					return false;
				}
				if (self.options.debug) console.warn('%cException - no return url', EBContext.options.consoleStyles.warnMsg);
			}
			if (self.options.debug) console.warn('%cException - no saved state', EBContext.options.consoleStyles.warnMsg);
			window.location.reload();
			return false;
		});

		// trigger AjaxNavigation.ready() also for non-ajax load to unify onDocumentReady callback function
		if(document.readyState === 'complete'){
			self.ready();
		} else {
			window.addEventListener('load', function(){
				self.ready();
			}, {once: true});
		}
		
		// bind ajaxNav on first load
		var initElements = function(rs){
			var i;
			var bindElements = self.options.initElements || Object.keys(self.options.bindElements);
			for(i=0;i<bindElements.length;i++){
				self.bindElements(self.findElements(bindElements[i]), bindElements[i]);
			}
		};
		(['complete','interactive'].indexOf(document.readyState) > -1 ? initElements(document.readyState) : document.addEventListener('DOMContentLoaded', initElements));
		
		document.addEventListener('EBContext.ajaxNav.navigate', self.options.fnOnNavigation);
		document.addEventListener('EBContext.ajaxNav.navigated', self.options.fnPageInit);
		
		//@ts-ignore
		window.ajaxCall = function (url, async, callback, post, options) {
			if (!options) options = null;
			if (!post) post = null;
			if (!callback) callback = null;
			if (!async) console.warn('%cSynchronous requests on the main thread are depriciated! Request sent asynchronously.', EBContext.options.consoleStyles.code);
			self.ajaxCall(url, callback, post, options);
		};
	};

	/**
	 * @param {string} [elementType=this.options.defaultBindElement] Needs to match one of the keys in 'this.options.bindElements' object
	 * @param {(string|NodeList|jQuery|Element|HTMLDocument|HTMLCollection)} [searchScope=document] String needs to be CSS selector, jQuery needs to have array of elements
	 * @returns {(Array.<HTMLElement>|null)} 
	 */
	this.findElements = function (elementType, searchScope) {
		searchScope = searchScope || document;
		if (!elementType || !(elementType in self.options.bindElements)) {
			if (self.options.debug) console.info('%c@findElements: Unknown elementType (' + (elementType || 'null') + '). Proceeding with default elementType (' + self.options.defaultBindElement + ')...', EBContext.options.consoleStyles.infoMsg);
			elementType = self.options.defaultBindElement;
		}
		var typeOptions = self.options.bindElements[elementType];

		if (typeof searchScope === 'string') {
			return self.findElements(elementType, document.querySelectorAll(searchScope));
		} else if (searchScope instanceof NodeList || searchScope instanceof HTMLCollection) {
			return self.findElements(elementType, Array.prototype.slice.call(searchScope));
		} else if (searchScope instanceof Element || searchScope instanceof HTMLDocument) {
			return Array.prototype.slice.call(searchScope.querySelectorAll(typeOptions.selector));
		} else if ((window.jQuery && searchScope instanceof jQuery) || Array.isArray(searchScope)) {
			var elements = [];
			for (var i = 0; i < searchScope.length; i++) {
				if (searchScope[i] instanceof Element || searchScope[i] instanceof HTMLDocument) {
					elements = elements.concat(Array.prototype.slice.call(self.findElements(elementType, searchScope[i])));
				}
			}
			return elements;
		} else {
			console.error('%c' + searchScope.toString() + ' is not valid selector! Pass jQuery object, querySelector string, or array of DOM nodes, or nodeList.', EBContext.options.consoleStyles.errorMsg);
			return null;
		}
	};

	/**
	 * @param {Array.<HTMLElement>} elementsArray Set of elements to bind ajaxNavigation to
	 * @param {string} [elementType=this.options.defaultBindElement] Needs to match one of the keys in 'this.options.bindElements' object
	 * @returns {boolean} Returns `true` if any Elements were bound, `false` otherwise
	 */
	this.bindElements = function (elementsArray, elementType) {
		if (!elementType || !(elementType in self.options.bindElements)) {
			if (self.options.debug) console.info('%c@bindElements: Unknown elementType (' + (elementType || 'null') + '). Proceeding with default elementType (' + self.options.defaultBindElement + ')...', EBContext.options.consoleStyles.infoMsg);
			elementType = self.options.defaultBindElement;
		}
		var typeOptions = self.options.bindElements[elementType];
		if (elementsArray.length > 0) {
			for (var i = 0; i < elementsArray.length; i++) {
				if (typeOptions.fnTestElement(elementsArray[i])) {
					if (elementsArray[i].getAttribute('navBound') !== null) {
						//if (self.options.debug) console.warn('%cElement has already been bound to ajax navigation! Element: ' + EBContext.utils.element.getSelector(elementsArray[i]), EBContext.options.consoleStyles.warnMsg);
						continue;
					}
					typeOptions.fnBindElement(elementsArray[i]);
					elementsArray[i].setAttribute('navBound', '');
				}
			}
			return true;
		}
		return false;
	};

	/**
	 * @param {string|null} [url=window.location.href] URL to navigate to
	 * @param {string|null} [ajaxURL=EBContext.utils.createAjaxURL(url, options)] URL of AJAX call to navigate by
	 * @param {string|FormData|null} [postData=null] Stringified form data in queryString-like format
	 * @param {Object} [options={}]
	 * @param {Event} [event]
	 * @returns {boolean} Always `false`
	 */
	this.navigationTrigger = function (url, ajaxURL, postData, options, event) {
		options = options || {};
		var navigation = (!('navigation' in options) || options.navigation);
		if (!self.enabled || (navigation && !self.navigationEnabled)) return true;
		url = EBContext.utils.createURL(url, options);
		postData = postData || null;
		if (postData){
			if(typeof postData === 'function'){
				postData = postData();
			}
			if(postData.constructor.name === 'Object') {
				postData = EBContext.utils.paramsObjToStr(postData);
			}
			if(!(postData instanceof FormData) && typeof postData !== 'string'){
				postData = postData.toString();
			}
		}
		var scrollTop = ('scrollTop' in options && options.scrollTop ? options.scrollTop : (navigation ? self.options.scrollTop.defaultElement : ''));
		var reload = (options.reload || self.options.defaultReload.join(',') ); //self.options.defaultReload
		if(ajaxURL){
			if(ajaxURL.indexOf('?') > -1){
				reload = EBContext.utils.paramsStrToObj(ajaxURL.split('?')[1], true)['ebpageitemupdate'];
			} else {
				ajaxURL = null;
			}
		}
		if(!ajaxURL){
			ajaxURL = EBContext.utils.createAjaxURL(url, EBContext.utils.mergeObj(false, options, {reload: reload}));
			//ajaxURL = EBContext.utils.createAjaxURL(url, {reload: reload});
		}
		if(navigation) ajaxURL = EBContext.utils.extendURL(ajaxURL, {masterPage: EBContext.currentPage.masterPage}, true)
		
		// ulo�it aktu�ln� URL se spr�vn�m reloadem 
		if (navigation || (event && event instanceof PopStateEvent)) {
			self.navigationStatus = 'invoked';
			self.currentState.currentURL = window.location.href;
			self.currentState.returnURL = EBContext.utils.createAjaxURL(window.location.href, {
				reload: reload,
				masterPage: EBContext.currentPage.masterPage
			});
			self.saveState();
		}
		else {
			self.navigationStatus = '';
		}
		self.currentState.scroll = [window.scrollX,window.scrollY];

		// pokud se p�ech�z� na novou str�nku, tak se p�id�v� nov� z�znam historie
		if (navigation && !(event && event instanceof PopStateEvent)) {
			if(self.options.saveElementsState.enabled) self.currentState.savedElements = self.createElementsState();
			self.saveState();
			window.history.pushState(self.currentState, "", url);
		}

		// pokud se jedn� o navigaci v historii prohl�e�e, tak se p�ed aktualizac� stavov�ho objektu na�te ten aktu�ln� z event.state
		else if (event && event instanceof PopStateEvent) {
			self.currentState = event.state;
		}

		// aktualizace history.state objektu
		window.history.replaceState(self.currentState, null, ((navigation || options.updateURL) ? url : window.location.href));

		var i;
		if (navigation && self.options.requestQueue.cancelOldNavOnNav) {
			for (i = 0; i < self.ajaxQueue.length; i++) {
				self.ajaxQueue[i].cancelled = true;
			}
		} else if (!navigation && self.options.requestQueue.ignoreNonNavOnNav) {
			for (i = 0; i < self.ajaxQueue.length; i++) {
				if (!self.ajaxQueue[i].cancelled && self.ajaxQueue[i].navigation) {
					return false; //If there is pending navigation request, do not create any non-navigation requests until navigation request is proccessed
				}
			}
		}

		self.ajaxCall(ajaxURL, {
			beforeProcess: function (response, respOptions) {
				var historyNavigation = 0;
				if(postData instanceof FormData) postData = {};
				let responseObj = {};
				try {
					
				} catch (e) {}
				if (navigation) document.dispatchEvent(self.events.navigate);
				if (reload === 'BODY' || (response && response.html && response.html.BODY)) document.dispatchEvent(self.events.bodyReload);
				
				if (event && event instanceof PopStateEvent) { // Most likely history navigation
					historyNavigation = event.state.historyId - self.currentState.historyId;
					self.currentState = event.state;
					self.navigationStatus = 'navigated';
				} else if (navigation) { // Non-history navigation
					historyNavigation = 1;
					self.navigationStatus = 'navigated';
					var historyId = self.currentState.historyId || 0;
					historyId++;
					
					self.currentState = {
						userId: EBContext.session.user.id || '',
						returnURL: ajaxURL,
						postData: postData,
						historyId: historyId,
						httpStatus: respOptions.responseStatus,
						dump: []
					};

					if ('replaceURL' in options && options.replaceURL !== ''){
						url = options.replaceURL;
						window.history.replaceState(self.currentState, document.title, url);
					}
					self.currentState.currentURL = window.location.href;
					self.reloadsHistory[self.currentState.historyId] = reload;
				}
				
				if ((historyNavigation !== 0 || scrollTop) && (!self.options.scrollTop.mobileOnly || window.innerWidth <= self.options.scrollTop.maxScreenWidth)) {
					if (!self.options.scrollTop.upOnly || window.scrollY - document.querySelector(scrollTop).offsetTop > 0) {
						window.scrollTo(0, document.querySelector(scrollTop).offsetTop - self.options.scrollTop.topOffset);
					}
				}
				let ppd = self.currentState.processPostData || 1;
				self.currentState.processPostData = (navigation ? 0 : ppd);
				self.saveState();
			},
			beforeEval: function (response) {
				if(navigation){
					document.title = '';
					let el;
					el = document.head.querySelector("meta[name='keywords']");
					if(el) el.setAttribute("content", '');
					el = document.head.querySelector("meta[name='description']");
					if(el) el.setAttribute("content", '');
					el = document.head.querySelector("meta[property='og\\:title']");
					if(el) el.setAttribute("content", '');
					el = document.head.querySelector("meta[property='og\\:description']");
					if(el) el.setAttribute("content", '');
					
					if (response.hasOwnProperty('head')) {
						if (response.head.hasOwnProperty('title')) {
							document.title = response.head.title;
						}
						if (response.head.hasOwnProperty('meta') && typeof response.head.meta === 'object') {
							for (var key in response.head.meta) {
								var metaEl = document.querySelector('meta[name="' + key + '"]');
								if (metaEl instanceof HTMLMetaElement) {
									metaEl.content = response.head.meta[key];
								}
							}
						}
					}
				}
				if(self.currentState.savedElements && self.currentState.userId === EBContext.session.user.id){
					self.setElementsState(self.currentState.savedElements);
				}
				if(options.callback && typeof options.callback === 'function') options.callback(response.return);
			},
			afterEval: function () {
				if (navigation) document.dispatchEvent(self.events.navigated);
				if (reload === 'BODY') document.dispatchEvent(self.events.bodyReloaded);
				if (event && event instanceof PopStateEvent && event.state && event.state.scroll) {
					EBContext.ready(()=>window.scroll({left: event.state.scroll[0], top: event.state.scroll[1], behavior: 'auto'}));
				}
				self.navigationStatus = 'complete';
			}
		}, postData, {
			ctype: options.ctype,
			navigation: navigation,
			originalUrl: url,
			loader: options.loader,
			timeout: options.timeout
		});
		return false;
	};

	/**
	 * Replaces current window.history.state object with this.currentState
	 */
	this.saveState = function () {
		window.history.replaceState(self.currentState, document.title, window.location.href);
	};

	this.restoreElementState = function (element, elemObj) {
		if(!elemObj){
			let hState = history.state || {};
			let savedElements = hState.savedElements || [];
			let elementsStates = savedElements.filter(el=>el.attributes.id===element.id);
			if(elementsStates.length!==1) elementsStates = savedElements.filter(el=>(el.attributes.name===element.name && el.attributes.value===element.value));
			if(elementsStates.length!==1) elementsStates = savedElements.filter(el=>(el.attributes.name===element.name));
			if(elementsStates.length>1) return console.error('Element with disambiguous selector!');
			elemObj = elementsStates[0];
		}
		if(!elemObj) return;
		for (attr in elemObj.attributes) {
			if(element.getAttribute(attr) !== elemObj.attributes[attr]) element.setAttribute(attr, elemObj.attributes[attr]);
		}
		for (prop in elemObj.properties) {
			element[prop] = elemObj.properties[prop];
		}
	};
	
	this.setElementsState = function (elements, scope) {
		console.trace('%cRestoring elements state', 'color:#fff;background:#000', elements);
		var attr, prop;
		
		scope = scope || document;
		for (var obj in elements) {
			var elemObj = elements[obj];
			if ('id' in elemObj.attributes) {
				var element = scope.querySelector('#'+elemObj.attributes.id);
				if (element) this.restoreElementState(element, elemObj);
			} else if ('name' in elemObj.attributes) {
				var elms = scope.querySelectorAll('[name="' + elemObj.attributes.name + '"]');
				if (elms.length === 1) this.restoreElementState(elms[0], elemObj);
				else if (elemObj.attributes.value) { //Pro radio buttony, checkboxy, a v�eobecn� inputy bez id, se stejn�m name a p�ednastaven�mi hodnotami - S attributem 'value' m�sto property 'value' se tady pracuje schv�ln�!
					let elm = [...elms].find(el=>el.attributes.getNamedItem('value') === elem.attributes.value);
					if(elm) this.restoreElementState(elm, elemObj);
				} else {
					console.warn('%cDisambiguous element identification! Name: \'' + elemObj.attributes.name + '\' Value: \'' + elemObj.attributes.value, EBContext.options.consoleStyles.warnMsg);
				}
			}
		}
		console.debug('%cElements state restored', 'color:#fff;background:#000');
		document.dispatchEvent(self.events.elementsRestored);
	};

	/**
	 * Saves current page state into this.currentState
	 */
	this.createElementsState = function (scope) {
		scope = scope || document;
		var saveElemList = scope.querySelectorAll('[id][name]:not([data-save=off]),[id][data-save]:not([data-save=off])');
		var savedElements = [];
		for (var i = 0; i < saveElemList.length; i++) {
			if(!saveElemList[i].matches('[type="password"]')){ // neukl�dat hesla - pak se pos�laj� do GTM!
				savedElements.push(self.getElementState(saveElemList[i]));
				self.updateElementState(saveElemList[i]);
			}
		}
		console.trace('%cSaving elements state', 'color:#fff;background:#000', savedElements);
		return savedElements;
	};

	/**
	 * Returns selected properties and attributes of passed HTMLElement id unified Object
	 * @param {Element} element
	 * @todo Convert pushing into savedElements to returning object
	 */
	this.getElementState = function (element) {
		var elemObj = {};
		elemObj.element = element.nodeName.toLowerCase();
		elemObj.attributes = {};
		elemObj.properties = {};
		let ignoreAttributes = ['checked','selected'];
		for (var i = 0; i < element.attributes.length; i++) {
			if(!ignoreAttributes.includes(element.attributes[i].name)) elemObj.attributes[element.attributes[i].name] = element.attributes[i].value;
		}
		
		var properties = self.options.saveElementsState.templates.default;
		for (var selector in self.options.saveElementsState.templates) {
			if (element.matches(selector)) {
				properties = EBContext.utils.array.merge(properties, self.options.saveElementsState.templates[selector]);
			}
		}
		for (i = 0; i < properties.length; i++) {
			if (element[properties[i]]) {
				elemObj.properties[properties[i]] = element[properties[i]];
			}
		}
		return elemObj;
	};
	
	this.updateElementState = function (element) {
		// mus� se �e�it p��mo p�es history state a ne ajaxNav.currentState, aby �lo ukl�dat zm�nu stavu elementu bez jak�chkoliv dal��ch zm�n
		let hState = history.state || {};
		let savedElements = hState.savedElements || [];
		let elementsStates = savedElements.filter(el=>el.attributes.id===element.id);
		if(elementsStates.length!==1) elementsStates = savedElements.filter(el=>(el.attributes.name===element.name && el.attributes.value===element.value));
		if(elementsStates.length!==1) elementsStates = savedElements.filter(el=>(el.attributes.name===element.name));
		if(elementsStates.length>1) return console.error('Element with disambiguous selector!');
		let elementState = elementsStates[0];
		let index = savedElements.indexOf(elementState);
		if(index > -1){
			savedElements[index] = EBContext.ajaxNav.getElementState(element);
		} else {
			savedElements.push(EBContext.ajaxNav.getElementState(element));
		}
		hState.savedElements = savedElements;
		history.replaceState(hState, null);
	};

	/**
	 * @param {string} filename URL to target resource file
	 * @param {('js'|'css')} filetype Type of resource file
	 * @returns {HTMLElement} virtual DOM element intended for appending to document
	 */
	this.createJSCSSFile = function (filename, filetype) {
		var fileref;
		if (filetype == 'js') {
			fileref = document.createElement('script');
			fileref.setAttribute('src', filename);
		} else if (filetype == 'css') {
			fileref = document.createElement('link');
			fileref.setAttribute('rel', 'stylesheet');
			fileref.setAttribute('type', 'text/css');
			fileref.setAttribute('href', filename);
		}
		return fileref;
	};

	/**
	 * @param {string} filename URL of resource file to remove from DOM
	 * @param {('js'|'css')} filetype Type of resource file
	 * @returns {boolean} `true` if any matching JS/CSS elements were found, `false` otherwise
	 */
	this.removeJSCSSFile = function (filename, filetype) {
		var targetelement = (filetype == 'js' ? 'script' : (filetype == 'css' ? 'link' : 'none'));
		var targetattr = (filetype == 'js' ? 'src' : (filetype == 'css' ? 'href' : 'none'));
		var allsuspects = document.getElementsByTagName(targetelement);
		for (var i = allsuspects.length; i >= 0; i--) {
			if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)
				allsuspects[i].parentNode.removeChild(allsuspects[i]);
		}
		return (allsuspects.length > 0);
	};

	/**
	 * Function finds all scripts within string of code, and evaluates them
	 * @param {string} response String of HTML code (AJAX response string)
	 * @returns {boolean} `true` if all JS evaluated successfully, `false` otherwise
	 */
	this.evalJS = function (response, options) {
		var success = true;
		var pattern = /(<script type="text\/javascript">|<script>)[^\u9999]*?<\/script>/gim;
		var scripts = response.match(pattern);
		if (scripts) {
			for (var x = 0; x <= scripts.length - 1; x++) {
				var crlf = new RegExp(String.fromCharCode(8), 'g');
				var code = scripts[x].replace(/(<script type="text\/javascript">|<script type=text\/javascript>|<script>)/gi, '');
				code = code.replace(/<\/script>/gi, '').replace(crlf, '\n');
				try {
					window.eval(code);
				} catch (error) {
					// self.options.fnAjaxError(response, EBContext.utils.extendObj(false, {
					// 	error: error,
					// 	code: code,
					// 	verbose: 'Error evaluating fetched JS!',
					// 	loader: options.loader
					// }, options));
					console.error('Error while executing JS code', code, error);
					success = false;
				}
			}
		}
		return success;
	};

	/**
	 * @param {string} url URL for AJAX call
	 * @param {EBContext.modules.AjaxNavigation.ajaxCallback|EBContext.modules.AjaxNavigation.ajaxCallbackObject} callback
	 * @param {string|FormData|null} [post]
	 * @param {Object} [options]
	 * @returns {boolean} `false`
	 */
	this.ajaxCall = function (url, callback, post, options) {
		var rnd = new Date().getTime() + Math.random();
		var ctype = null;
		if (options) {
			if (typeof options === 'object' && options.constructor === Object) {
				if (options.hasOwnProperty('ctype')) ctype = options.ctype;
			} else if (typeof options == 'string') {
				ctype = options; //default behaviour - 4th parameter was originally ctype
				options = {};
			}
		}

		options = options || {};
		if (!options.loader) {
			options.loader = self.options.loader;
		}
		if(!EBContext.modules.Loader || !(options.loader instanceof EBContext.modules.Loader)){ // kdy� nen� EBContext.modules.Loader na�ten�, tak options.loader nem��e b�t jeho instanc�...
			Object.entries(self.options.loader).forEach(ent=>{
				if(!options.loader.hasOwnProperty(ent[0])) options.loader[ent[0]] = ent[1];
			});
		}
		if (options.loader.enabled && options.loader.ajaxQueue.length == 0) options.loader.fnLoaderStart(options.loader);
		if(EBContext.utils.isPlainObj(post)) post = EBContext.utils.paramsObjToStr(post);

		options.url = url;
		options.post = post;
		options.callback = callback;
		
		var xhrCallback = EBContext.utils.extendObj(false, {
			ok: function (response, status) {
				options.responseStatus = status;
				self.ajaxResponse(url, response, callback, options);
			},
			err: function (response, status) {
				options.responseStatus = status;
				if(status === 404 || status === 401){
					// url = options.originalUrl || url; // url se nesm� zm�nit, proto�e pak se nenap�ruje response na request a z�st�v� mot�tko!
					self.currentState.currentURL = url;
					self.currentState.returnURL = EBContext.utils.createAjaxURL(window.location.href, {reload: 'BODY'});
					self.saveState();
					// window.location.href = url;
					// return false;
					self.ajaxResponse(url, response, callback, options);
				} else {
					self.ajaxResponse(url, response, {
						noResponse: self.options.fnAjaxError,
						afterEval: self.options.fnAjaxError,
						evalError: self.options.fnAjaxError
					}, options);
				}
			},
			redirect: function (expectedURL, xhr) {
				if(options.ignoreRedirects) return;
				let urlArr = (xhr.responseURL+'#').split('#');
				let urlAnchor = urlArr[1];
				urlArr = (urlArr[0]+'?').split('?');
				let urlParams = EBContext.utils.paramsStrToObj(urlArr[1], true);
				let urlBase = urlArr[0];
				
				delete urlParams.ebpageitemupdate;
				delete urlParams.ajax;
				delete urlParams.userid;
				delete urlParams.ver;
				
				let paramsStr = EBContext.utils.paramsObjToStr(urlParams)
				let newURL = urlBase + (paramsStr ? '?' + paramsStr : '');
				options.replaceURL = newURL;
				if(options && options.navigation){
					window.history.pushState(self.currentState, null, newURL);
				} else {
					window.history.replaceState(self.currentState, null, newURL);
				}
			},
			timeout: null
		}, options.xhrCallback);
		
		let charset = null;
		let headers = [];
		
		//url += '&version=' + EBContext.data.session.version;
		if (EBContext.session && EBContext.session.user) url += '&userId=' + EBContext.session.user.id; //kdy� existuje obj user, tak id nen� undefined.
		url += '&ver='+self.version; //&lng="+EBContext.data.language+'
		options.loader.ajaxQueue.unshift({
			url: url,
			cancelled: false,
			navigation: ((options && options.navigation) || false)
		});
		EBContext.utils.xmlHttp({
			url: url,
			method: (post ? 'POST' : 'GET'),
			data: post,
			ctype: ctype,
			charset: charset,
			timeout: options.timeout || 300000,
			headers: headers,
			callback: xhrCallback
		});
		return false;
	};

	this.call = function(call, callback, post, url, params, options){
		url = url || window.location.href;
		let ajaxURL = EBContext.utils.createAjaxURL(url, {call: call, requestParams: params});
		self.ajaxCall(ajaxURL, callback, post, options);
	};

	/**
	 * @param {string} url URL of AJAX request figuring primaily as an identification of requests
	 * @param {string} response Response string from AJAX request
	 * @param {EBContext.modules.AjaxNavigation.ajaxCallback|EBContext.modules.AjaxNavigation.ajaxCallbackObject} callback
	 * @param {EBContext.modules.AjaxNavigation.ajaxResponseOptions} options
	 * @returns {*} Returns response.return, or `false`
	 */
	this.ajaxResponse = function (url, response, callback, options) {
		if (self.options.debug) console.log('%cResponse for \'' + url + '\' received.', EBContext.options.consoleStyles.infoMsg);
		var nextResponse = function () {
			options.loader.ajaxQueue.pop();
			delete self.ajaxResponses[url];

			if (options.loader.ajaxQueue.length > 0) {
				var nextRequest = options.loader.ajaxQueue[options.loader.ajaxQueue.length - 1];

				if (self.options.debug) console.log('nextResponse: \'' + nextRequest.url + '\'');
				if (nextRequest.url in self.ajaxResponses) {
					var nextResponse = self.ajaxResponses[nextRequest.url];
					return self.ajaxResponse(nextRequest.url, nextResponse.response, nextResponse.callback, nextResponse.options);
				}
			} else {
				EBContext.ready(()=>options.loader.fnLoaderEnd(options.loader));
			}
			return false;
		};

		var oldestRequest = options.loader.ajaxQueue[options.loader.ajaxQueue.length - 1];
		if (oldestRequest && oldestRequest.url === url) {
			if (self.options.debug) console.log('%cProccessing response for \'' + url + '\'.', EBContext.options.consoleStyles.infoMsg);

			// If there is more than one navigation requests, only the latest is active, others will be cancelled
			if (oldestRequest.cancelled) {
				if (self.options.debug) console.log('%cNavigation to \'' + url + '\' was cancelled.', EBContext.options.consoleStyles.infoMsg);
				return nextResponse();
			}

			// If multipoint callback object is passed, set it to callbackObj, and assign callback passed afterEval function
			var callbackObj = {};
			if (callback && typeof callback === 'object') {
				callbackObj = callback;
				callback = null;
				if (callbackObj.afterEval && typeof callbackObj.afterEval === 'function') callback = callbackObj.afterEval;
			}
			if (options.navigation) {
				self.currentState.httpStatus = options.responseStatus;
				self.saveState();
			}

			//there is a response - let's proccess it!
			if (response) {

				var responseObj = {};

				// Parsing response string to a JS Object surrounded with try/catch construction
				try {
					eval('responseObj = ' + response.substring(response.indexOf('{'))); // jshint ignore:line
				} catch (error) {
					if (callbackObj.evalError && typeof callbackObj.evalError === 'function') {
						callbackObj.evalError(response, options);
					} else {
						var evalError = (callbackObj.evalError || 'undefined').toString();
						self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
							error: error,
							code: evalError,
							verbose: 'Error evaluating AJAX response!'
						}));
					}
					return nextResponse();
				}
				
				// If multipoint callback contains beforeProcess function, call it now
				if (callbackObj.beforeProcess && typeof callbackObj.beforeProcess === 'function') {
					try {
						callbackObj.beforeProcess(responseObj, options);
					} catch (error) {
						self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
							error: error,
							code: callbackObj.beforeProcess.toString(),
							verbose: 'Error executing \'beforeProcess\' callback function!'
						}));
					}
				}

				if (self.options.debug) console.log('PAGETIME', responseObj.pageTime, url);
				if (options.navigation) {
					let defaultPageObj = {OID: null, blocksData: {}, pageData: {}, eventListeners: []};
					let currentPageObj = EBContext.currentPage || defaultPageObj;
					let currentPageOID = currentPageObj.OID;
					let newPageOID = responseObj.OID || null;
					currentPageObj.eventListeners.forEach(elObj=>document.removeEventListener(elObj.eName, elObj.eHandler, elObj.eCapture));
					if(currentPageOID !== newPageOID){
						if(currentPageOID) EBContext.utils.setObj(EBContext, ['pages',currentPageOID], currentPageObj);
						if(newPageOID){
							currentPageObj = EBContext.utils.getObj(['pages',newPageOID], EBContext) || defaultPageObj;
							currentPageObj.OID = newPageOID;
						}
					}
				}
				if (options.responseStatus === 0 || (options.responseStatus > 399 && [401,404].indexOf(options.responseStatus) === -1)) { // pro k�dy 401 a 404 jsou zpracovan� samostatn� str�nky, tak nevyhazovat jako popup
					var errCallback = callbackObj.onError || self.options.fnAjaxError;
					errCallback(response, EBContext.utils.mergeObj(false, options, {
						verbose: EBContext.utils.getObj('head.title', responseObj) || EBContext.resource('MSG_CHYBA_' + options.responseStatus),
						code: response
					}));
					return nextResponse();
				}
				if (responseObj.notification) {
					require(['EBContext_Modal'], ()=>{
						EBContext.alert(responseObj.notification, null, { heading: EBContext.resource('UPOZORNENI')});
					});
				}
				if (responseObj.requiredAge) {
					require(['EBContext_SessionUtils'], ()=>{
						EBContext.ready(() => EBContext.session.validateAge(responseObj.requiredAge));
					});
				}
				if(responseObj.session){
					EBContext.utils.extendObj(false, EBContext.data.session, responseObj.session);
				}
				if(responseObj.dump && Object.keys(responseObj.dump).length){
					EBContext.ajaxNav.currentState.dump.push({url: url, dump: responseObj.dump});
					console.debug('%cDump%c URL: %s\n%O', EBContext.options.consoleStyles.warnBtn, '', url, responseObj.dump);
					let eblogEl = document.getElementById('eblog');
					if(eblogEl){
						let logStr = responseObj.dump.ebLogHTML || '';
						if(!logStr && responseObj.dump.ebLog) logStr = responseObj.dump.ebLog.join('<br>');
						if(options.navigation){
							eblogEl.innerHTML = logStr;
						} else {
							eblogEl.innerHTML += '<details><summary class="alert alert-info mt-3">Request URL: <b>' + url + '</b></summary><div class="ps-2">' + logStr + '</div></details>';
						}
					}
				}
				let currentUser = EBContext.session.user.id || '',
					responseUser = responseObj.userId || '',
					currentVersion = !EBContext.data || !EBContext.data.session || EBContext.data.session.version || '',
					responseVersion = responseObj.version || '',
					responseParams = responseObj.responseparams || {};
				console.warn('%cajax response user', 'color:#fff;background:#000;border:1px solid red;display:block;min-height:4rem', {
					responseUrl: url, 
					currentUserId: currentUser,
					responseUserId: responseUser, 
					currentVersion: currentVersion, 
					responseVersion: responseVersion
				});
				if(responseObj.masterPage) EBContext.currentPage.masterPage = responseObj.masterPage;
				if(!options.navigation && self.skipReloads){
					// ' Nem��e se reloadovat, jinak se ztrat� MSG v ko��ku po n�vratu z platebn� br�ny - TODO'
				} else if (responseUser !== currentUser || currentVersion !== responseVersion) {
					self.skipReload = false; // po naviga�n�m requestu u� ale reloady prov�d�t...
					if(responseUser !== currentUser){
						require(['EBContext_SessionUtils','EBContext_TabSync'], ()=>{
							if(EBContext.session.user.auth) EBContext.session.user.clearSession(); //session mazat jen pokud byl user p�ihl�en�, jinak to ma�e Auth cookie p�i p�ihl�en�!
    						EBContext.session.user.id = responseUser;
    						EBContext.tabSync.update('userId', responseUser);
                        });
					}
					console.warn('reload',EBContext.session.user.id, responseUser, currentVersion, responseVersion);
					if(options.responseStatus === 401 && (typeof responseObj.userId == 'undefined' || typeof responseObj.version == 'undefined')) return window.location.reload();
					if(options.navigation && currentVersion !== responseVersion) return window.location.reload();
					EBContext.ajaxNav.navigationTrigger(responseParams.redirect, null, null, {reload: 'BODY', navigation: false, updateURL: true, requestParams: {session: 1}, callback: ()=>{
						console.log('reload done');
						if (responseUser !== currentUser) {
							if (responseUser === '') {
								require(['EBContext_SessionUtils'], ()=>{
									EBContext.session.notify(EBContext.resource('MSG_LOGOUT_SUCCESS'), 'success');
									document.dispatchEvent(EBContext.session.events.logout);
									console.info('Logout success');
								});
							}
							else {
								require(['EBContext_SessionUtils'], ()=>{
									EBContext.session.notify(EBContext.resource('MSG_LOGIN_SUCCESS'), 'success');
									document.dispatchEvent(EBContext.session.events.login);
									console.info('Login success');
								});
							}
						}
					}});
				}
			
				var subPage = document.getElementById(self.options.defaultSubPage) || document.body;
				if (false && !subPage) {
					self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
						verbose: 'SubPage element with id \'' + self.options.defaultSubPage + '\' was not found!'
					}));
				}
				var pageOID = EBContext.config.currentPage;
				var pageVersion = EBContext.config.version;
				var elm, r;

				// Replace requested HTML in DOM tree
				var crlf = new RegExp(String.fromCharCode(8), 'g');
				for (r in responseObj.html) {
					if(r === 'BODY') subPage = document.body;
					
					var append = false;
					var elemId = r;
					var parserEl = null;
					if (r.substr(-1) === '<') {
						append = true;
						elemId = r.substr(0, r.length - 1);
					}
					elm = document.getElementById(elemId);
					if (elm) {
						if (append) {
							parserEl = document.createElement(elm.tagName);

							// @TEST - snad toto poberou v�echny prohl�e�e. Jak�koliv ofici�ln� JS �e�en� na parsov�n� HTML je pro pou�it� m�lo kompatibiln�
							parserEl.innerHTML = responseObj.html[r].replace(crlf, '\n');
							while (parserEl.firstChild) {
								elm.appendChild(parserEl.removeChild(parserEl.firstChild));
							}

						} else {
							elm.innerHTML = responseObj.html[r].replace(crlf, '\n');
						}
						for (var elementType in self.options.bindElements) {
							self.bindElements(self.findElements(elementType, elm), elementType);
						}
					} else {
						console.error('%cCannot replace content of an element. Element #' + elemId + ' was not found.', EBContext.options.consoleStyles.errorMsg);
					}
				}

				if (callbackObj.beforeHeadUpdate && typeof callbackObj.beforeHeadUpdate === 'function') {
					try {
						callbackObj.beforeHeadUpdate(responseObj.return, options);
					} catch (error) {
						self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
							error: error,
							code: callbackObj.beforeHeadUpdate.toString(),
							verbose: 'Error executing \'beforeHeadUpdate\' callback function!'
						}));
					}
				}

				// If the page OID or version is different from current page, we need to reload local JS/CSS. In other case there is no point, because it should be the same 
				if (responseObj.hasOwnProperty('OID')) pageOID = responseObj.OID;
				if (responseObj.hasOwnProperty('version')) pageVersion = responseObj.version;
				if (self.hasOwnProperty('onAfterNavigation')) delete self.onAfterNavigation;
				if ((pageOID !== EBContext.config.currentPage || pageVersion !== EBContext.config.version) && responseObj.html !== {}) {
					self.removeJSCSSFile('/getcss.asp?subPage=1&ebPageOid=' + EBContext.config.currentPage + '&version=' + EBContext.config.version, 'css');
					self.removeJSCSSFile('/getjs.asp?subPage=1&ebPageOid=' + EBContext.config.currentPage + '&version=' + EBContext.config.version, 'js');
					
					EBContext.config.currentPage = pageOID || '';
					EBContext.config.version = pageVersion || '';

					var subPageScript = self.createJSCSSFile('/getjs.asp?subPage=1&ebPageOid=' + EBContext.config.currentPage + '&version=' + EBContext.config.version, 'js');
					var subPageStyle = self.createJSCSSFile('/getcss.asp?subPage=1&ebPageOid=' + EBContext.config.currentPage + '&version=' + EBContext.config.version, 'css');

					self.subPageScriptEvt = function (event) {
						subPageScript.removeEventListener('load', self.subPageScriptEvt, true);
						subPageScript.removeEventListener('error', self.subPageScriptEvt, true);

						if (callbackObj.beforeEval && typeof callbackObj.beforeEval === 'function') {
							try {
								callbackObj.beforeEval(responseObj, options);
							} catch (error) {
								self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
									error: error,
									code: callbackObj.beforeEval.toString(),
									verbose: 'Error executing \'beforeEval\' callback function!'
								}));
							}
						}
						for (r in responseObj.html) self.evalJS(responseObj.html[r], options);
						
						if (options && options.navigation && self.onAfterNavigation && typeof self.onAfterNavigation === 'function') {
							try {
								self.onAfterNavigation(self.currentState.pageData || {});
							} catch (error) {
								self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
									error: error,
									code: self.onAfterNavigation.toString(),
									verbose: 'Error executing \'onAfterNavigation\' callback function!'
								}));
							}
						}

						// afterEval callback
						if (callback && typeof callback === 'function') {
							try {
								callback(responseObj.return, options);
							} catch (error) {
								self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
									error: error,
									code: callback.toString(),
									verbose: 'Error executing main callback function!',
									dependent: true
								}));
							}
						}
						self.ready();
					};

					subPageScript.addEventListener('load', self.subPageScriptEvt, true);
					subPageScript.addEventListener('error', self.subPageScriptEvt, true);
					
					if(!subPage) return window.location.reload();
					
					subPage.insertBefore(subPageScript, subPage.firstChild);
					subPage.insertBefore(subPageStyle, subPage.firstChild);
				} else {
					if (callbackObj.beforeEval && typeof callbackObj.beforeEval === 'function') {
						try {
							callbackObj.beforeEval(responseObj, options);
						} catch (error) {
							self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
								error: error,
								code: callbackObj.beforeEval.toString(),
								verbose: 'Error executing \'beforeEval\' callback function!'
							}));
						}
					}
					for (r in responseObj.html) self.evalJS(responseObj.html[r], options);
					
					// afterEval callback
					if (callback && typeof callback === 'function') {
						try {
							callback(responseObj.return, options);
						} catch (error) {
							self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
								error: error,
								code: callback.toString(),
								verbose: 'Error executing main callback function!',
								dependent: true
							}));
						}
					}
					
					self.ready();
				}

				if (callbackObj.beforeScopedInit && typeof callbackObj.beforeScopedInit === 'function') {
					try {
						callbackObj.beforeScopedInit(responseObj.return, options);
					} catch (error) {
						self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
							error: error,
							code: callbackObj.beforeScopedInit.toString(),
							verbose: 'Error executing \'beforeScopedInit\' callback function!'
						}));
					}
				}

				for (r in responseObj.html) {
					elm = document.getElementById(r);
					if (elm && typeof self.options.fnBlockInit === 'function') {
						self.options.fnBlockInit(elm);
					}
				}

				if (typeof response === 'object' && responseObj.return !== undefined) {
					nextResponse();
					if (self.options.debug) console.log('return:' + responseObj.return);
					return responseObj.return;
				}
				return nextResponse();
			} else {
				if (callbackObj.noResponse && typeof callbackObj.noResponse === 'function') {
					try {
						callbackObj.noResponse(response, options);
					} catch (error) {
						self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
							error: error,
							code: callbackObj.noResponse.toString(),
							verbose: 'No response from ajax call!'
						}));
					}
				} else {
					self.options.fnAjaxError(response, EBContext.utils.mergeObj(false, options, {
						verbose: 'No response from ajax call!'
					}));
				}
				return nextResponse();
			}
		} else {
			if (!oldestRequest) {
				console.log('%cNo request to proccess!', EBContext.options.consoleStyles.errorMsg);
			} else {
				if (self.options.debug) {
					console.log('%cResponse is out of order.\nResponse from \'' + url + '\' was queued.\nExpected url: \'' + oldestRequest.url + '\'', EBContext.options.consoleStyles.infoMsg);
				}
				self.ajaxResponses[url] = {
					response: response,
					callback: callback,
					options: options
				};
			}
		}
	};
	
	/**
	 * @param {function} [callback] Function without any parameters. If defined, will be added to callbacks queue. If undefined, callbacks queue will be executed.
	 * @returns {boolean} `true` if called without parameters (to execute callbacks in queue) or if passed callback function was successfully added to the queue, else `false`. 
	 */
	this.ready = function (callback) {
		if (callback == undefined) {
			while (self.onload.length > 0) {
				callback = self.onload.pop();
				if (typeof callback === 'function') callback();
				else console.error('%cCallback is not a function! Skipping execution.', EBContext.options.consoleStyles.warnMsg);
			}
			document.dispatchEvent(self.events.ready);
			return true;
		} else if (typeof callback === 'function') {
			if(self.navigationStatus === 'complete' || !self.navigationStatus){
				require(['EBContext_SessionUtils'], ()=>{
					callback();
				});
			} else {
				self.onload.push(callback);
			}
			return true;
		}
		console.error('%cCallback is not a function!', EBContext.options.consoleStyles.errorMsg, callback);
		return false;
	};
	this.init();
	return this;
};

/**
 * Instance of AjaxNavigation
 * @name ajaxNav
 * @memberof EBContext
 * @type {EBContext.modules.AjaxNavigation}
 */
EBContext.ajaxNav = new EBContext.modules.AjaxNavigation();
document.addEventListener('EBContext.ajaxNav.navigated', ()=>{
	document.activeElement.blur();
});
document.addEventListener('EBContext.ajaxNav.bodyReload', ()=>{
	document.body.classList.add('preload-initial');
});
// document.addEventListener('EBContext.ajaxNav.bodyReloaded', EBContext.preloader.show);

require(['EBContext_SessionUtils','EBContext_Analytics'], ()=>{
	let initPageInteraction = ()=>{
		if(EBContext.analytics.services.length) document.addEventListener('EBContext.ajaxNav.navigated', ()=>{EBContext.analytics.fire('page_view_interaction', {})});
	};
	if(EBContext.session.cookie.check()){
		initPageInteraction();
	} else {
		document.addEventListener('EBContext.session.confirmConsent', initPageInteraction, {once:true});
	}
});

EBContext.actions.goto = function(url){
	window.location.href=url;
};

ebc.an = EBContext.ajaxNav;